'use strict';
/* global __ENV_IS_BBC__:false, __DEBUG__:false, __WATCH__:false */
import Phaser from 'phaser';
import BootState from 'app/states/Boot';
import LoadState from 'app/states/Load';
import WelcomeState from 'app/states/Welcome';
import WorldMapState from 'app/states/WorldMap';
import LocationState from 'app/states/Location';
import LocationLoaderState from 'app/states/LocationLoader';
import SuitcaseState from 'app/states/Suitcase';
import HowToPlayState from 'app/states/HowToPlay';
import AnimStoryIntroState from 'app/states/AnimaticStoryIntro';
import AnimStoryEndState from 'app/states/AnimaticStoryEnd';
import AnimStoryLocationState from 'app/states/AnimaticStoryLocation';
import MiniGameLoaderState from 'app/states/MiniGameLoader';
import MiniGameFoodState from 'app/states/MiniGameFood';
import MiniGameChaseState from 'app/states/MiniGameChase';

import SoundController from 'app/controller/SoundController';
import AspectController from 'app/controller/AspectController';
import WindowEventController from 'app/controller/WindowEventController';

import {
  STATE_LOCATION,
  GAME_DIV_CLASSNAME,
  GAME_DIV_ID,
  GAME_HEIGHT_DEFAULT,
  GAME_WIDTH_DEFAULT,
  STATE_BOOT,
  STATE_LOAD,
  STATE_WELCOME,
  STATE_WORLD_MAP,
  STATE_LOCATION_LOADER,
  STATE_SUITCASE,
  STATE_HOWTOPLAY,
  STATE_ANIM_STORY_END,
  STATE_ANIM_STORY_INTRO,
  STATE_ANIM_STORY_LOCATION,
  STATE_MINIGAME_CHASE,
  STATE_MINIGAME_LOADER,
  STATE_MINIGAME_FOOD,
} from './app/constants/AppConstants';

export default class App extends Phaser.Game {
  constructor({ dom_element, settings, deviceController, shortcuts }) {
    let renderMode = Phaser.AUTO;
    if (deviceController.isOldIpad) {
      renderMode = Phaser.CANVAS;
    }

    // found the is wor d to perform better on android (samsungs9 with canvas )
    // TODO : check iOS
    renderMode = Phaser.CANVAS;

    super(GAME_WIDTH_DEFAULT, GAME_HEIGHT_DEFAULT, renderMode, GAME_DIV_ID, null);
    this.shortcutsEnabled = shortcuts;
    window.app = this;

    // define default dimensions
    this.defaultWidth = GAME_WIDTH_DEFAULT;
    this.defaultHeight = GAME_HEIGHT_DEFAULT;
    this.offsetWidth = 0;
    this.offsetHeight = 0;
    this.screenPadding = Math.max(this.width, this.height) * 0.02;

    // prep page game container ( do we even need this ? )
    this.gameContainer = document.getElementById(GAME_DIV_ID);
    this.gameContainer.className = GAME_DIV_CLASSNAME;
    // this.createAccessibilityContainer();

    this.settings = settings;

    // add the game controller
    this.deviceController = deviceController;
    // this.controller = new GameController(this);
    this.aspectController = new AspectController(this);
    this.windowEventController = new WindowEventController(this, true);

    // make some noise! whoop whoop!
    this.sounds = new SoundController({ game: this, settings });

    // set our states
    this.state.add(STATE_BOOT, BootState, false);
    this.state.add(STATE_LOAD, LoadState, false);
    this.state.add(STATE_WELCOME, WelcomeState, false);
    this.state.add(STATE_WORLD_MAP, WorldMapState, false);
    this.state.add(STATE_LOCATION, LocationState, false);
    this.state.add(STATE_LOCATION_LOADER, LocationLoaderState, false);
    this.state.add(STATE_SUITCASE, SuitcaseState, false);
    this.state.add(STATE_HOWTOPLAY, HowToPlayState, false);
    this.state.add(STATE_ANIM_STORY_END, AnimStoryEndState);
    this.state.add(STATE_ANIM_STORY_INTRO, AnimStoryIntroState, false);
    this.state.add(STATE_ANIM_STORY_LOCATION, AnimStoryLocationState, false);
    this.state.add(STATE_MINIGAME_CHASE, MiniGameChaseState, false);
    this.state.add(STATE_MINIGAME_FOOD, MiniGameFoodState, false);
    this.state.add(STATE_MINIGAME_LOADER, MiniGameLoaderState, false);

    // start
    this.state.start(STATE_BOOT, true, false);
  }

  shouldEnableShortcuts() {
    return this.shortcutsEnabled;
  }

  log(message, ...args) {
    console.log('LOGGGING');

    if (__DEBUG__) {
      const styl = 'color: blue; font-weight: bold';

      if (message.indexOf('Starting Game') !== -1) {
        console.log(`\n%c${message}`, styl, '\n ');
      } else {
        if (args) {
          let a = [];
          args.forEach((arg) => {
            a.push(arg);
            a.push('\n');
          });
          console.log(`\n%c${message}`, styl, '\n\n', ...a, '\n ');
          // console.log('\n' + message + '\n\n  ', ...args, '\n ');
        } else {
          console.log(`\n%c${message}`, styl, '\n ');
        }
      }
    }
  }

  logWarning(message, ...args) {
    if (__DEBUG__) {
      const styl = 'color: red; font-weight: bold';

      if (message.indexOf('Starting Game') !== -1) {
        console.log(`\n%c${message}`, styl, '\n ');
      } else {
        if (args) {
          let a = [];
          args.forEach((arg) => {
            a.push(arg);
            a.push('\n');
          });
          console.log(`\n%c${message}`, styl, '\n\n', ...a, '\n ');
          // console.log('\n' + message + '\n\n  ', ...args, '\n ');
        } else {
          console.log(`\n%c${message}`, styl, '\n ');
        }
      }
    }
  }

  destroyBitmapData(bitmapData) {
    bitmapData.clear();
    bitmapData.width = 1;
    bitmapData.height = 1;
    bitmapData.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/App.js